import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCursorCross = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Cursor/Cross",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "cross",
			children: [/* @__PURE__ */ _jsx("g", { id: "Layer 1 2" }), /* @__PURE__ */ _jsx("g", {
				id: "Layer 2 2",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Shape_2",
					d: "M8 7V1H7V7H1V8H7V14H8V8H14V7H8Z",
					fill: "#232020"
				})
			})]
		})
	})
});
export default SvgCursorCross;
